<template>
  <div>
    <div v-for="(item, index) in this.items" :key="index">
      <span> {{ attachments[item.id] }} x {{ item.number }}</span>
      <span v-if="item.icon">&nbsp;&nbsp;(图标：{{ item.icon }})</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      attachments: {},
    };
  },

  async created() {
    this.attachments = await this.$bizutil.loadAttachments(true);
  },

  props: {
    items: Array,
  },

  computed: {},

  methods: {},
};
</script>

<style lang="scss" scoped>
.number-input {
  width: 80px;
}
</style>